import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'
import * as filters from '../../filters/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-linerunlocation-dropdown',
  templateUrl: './LineRunLocationDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => LineRunLocationDropdownComponent)}]
})
export class LineRunLocationDropdownComponent extends BaseDropdownComponent {

    
    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }


    ngOnInit(): void {
    }

    public load(){
        var filter: filters.LineRunLocationFilter = {IncludeInactive: false};
        this.domainDataService.getLineRunLocations(filter).subscribe(x=> this.onGetLineRunLocationsDone(x));
    }
    
    onGetLineRunLocationsDone(items: ent.LineRunLocation[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        this.value = this.selectedID;
    }

}